<div class="input-group">
    <div class="input-group-prepend">
        <span class="input-group-text">{{codigoIntegracaoErp}}</span>
    </div>
    <input type="text" class="form-control" [value]="nome" disabled="disabled" readonly="readonly">
</div>
<p class="form-text text-muted nome-fantasia-cnpj-cpf">
    {{nomeFantasia}} <span *ngIf="cnpjCpf"> - {{cnpjCpf}} </span>
</p>